export default "__VITE_PUBLIC_ASSET__3ff82bab__"